import { COLOR, Lightbox, Toast } from '@cosuno/cosuno-ui';
import { DownloadPreparationMessage } from '@cosuno/files-frontend';
import { NavigationBlocker } from '@cosuno/react-router';
import React, { memo, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { useNavatticSetup } from '~/packages/navattic';
import GetStarted from '~/shared/components/GetStarted';
import HtmlHeadTags from '~/shared/components/HtmlHeadTags';
import useAnalytics from '~/shared/hooks/useAnalytics';

import AppOutdatedNotifier from './AppOutdatedNotifier';
import NavigationConfirmationPrompt from './NavigationConfirmationPrompt';
import {
  AgentUserLimitedAccessPrompt,
  ContractEndingPrompt,
  OverdueInvoiceWarning,
  SubcontractorProfilePrompt,
} from './Prompts';
import PromptsWrapper from './PromptsWrapper';

const AppContent: React.FC = () => {
  const { trackEvent } = useAnalytics();

  useNavatticSetup();

  useEffect(() => {
    const trackNonLeftMouseLinkClick = (event: MouseEvent) => {
      const buttons = {
        left: 0,
        middle: 1,
        right: 2,
      };

      if (
        event.target instanceof HTMLAnchorElement &&
        [buttons.middle, buttons.right].includes(event.button)
      ) {
        trackEvent('nonLeftMouseLinkClick', { href: event.target.href });
      }
    };

    document.body.addEventListener('mousedown', trackNonLeftMouseLinkClick);

    return () => {
      document.body.removeEventListener('mousedown', trackNonLeftMouseLinkClick);
    };
  }, [trackEvent]);

  return (
    <NavigationConfirmationPrompt>
      <AppOutdatedNotifier>
        <HtmlHeadTags title={null} themeColor={COLOR.white} />
        <PromptsWrapper>
          <OverdueInvoiceWarning />
          <SubcontractorProfilePrompt />
          <AgentUserLimitedAccessPrompt />
          <ContractEndingPrompt />
        </PromptsWrapper>
        <Toast />
        <NavigationBlocker>
          <Outlet />
        </NavigationBlocker>
        <Lightbox />
        <DownloadPreparationMessage />
        <GetStarted />
      </AppOutdatedNotifier>
    </NavigationConfirmationPrompt>
  );
};

export default memo(AppContent);
